// extracted by mini-css-extract-plugin
export var timedOutModal = "TimedOutModal-module--timedOutModal--3RZzW";
export var timedOutModal__content = "TimedOutModal-module--timedOutModal__content--Pg7JG";
export var timedOutModal__title = "TimedOutModal-module--timedOutModal__title--3LENZ";
export var timedOutModal__body = "TimedOutModal-module--timedOutModal__body--3qo-R";
export var timedOutModal__button = "TimedOutModal-module--timedOutModal__button--3mCT7";
export var timedOutModal__buttongroup = "TimedOutModal-module--timedOutModal__buttongroup--1XD91";